export default "__VITE_ASSET__46540303__"